import { ChangeDetectorRef, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { data } from 'jquery';
// import { Row } from 'jspdf-autotable';
import { AuditOverviewService } from 'src/app/services/Audit/audit-overview.service';
import { QuestionsService } from 'src/app/services/Audit/questions-table.service';
import { DataService } from 'src/app/services/data.service';
import { AddNewQuestionComponent } from '../add-new-question/add-new-question.component';
import { ToastrService } from 'ngx-toastr';
import { MatSelectModule } from "@angular/material/select";

@Component({
  selector: "app-question-master",
  templateUrl: "./question-master.component.html",
  styleUrls: ["./question-master.component.css"],
})
export class QuestionMasterComponent {
  displayedColumns = ["SubCategoryName", "Question", "Weightage", "actions"];
  filterValue = "";
  dataSource: MatTableDataSource<questionType>;
  dataSourceMap: Map<number, MatTableDataSource<questionType>> = new Map();
  dataArray = new Array();
  newWeightage: string = "";
  newSubCategory: number = 0;
  newCategory: number = 0;
  newQuestion: string = "";
  newTechnology: number = 0;
  currentCategoryId: number = 0;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  categories: any;
  subCategories = [];
  technologies = [];

  constructor(
    private auditOverviewService: AuditOverviewService,
    private questionsService: QuestionsService,
    private cdr: ChangeDetectorRef, 
    private dialog: MatDialog,
  ) {
    const users: questionType[] = [];
  }

  ngOnInit(): void {
    this.getCategories();
    this.getsubCategories();
    this.getTechnologies();
  }
  ngAfterViewInit() {
    // this.dataSource.paginator = this.paginator;
    // this.dataSource.sort = this.sort;
  }

  openAddDialog() {
    var _popUp = this.dialog.open(AddNewCategoryDialog, {
      width: '30%',
      data: { isAddNewQuestion: true}
    });
    _popUp.afterClosed().subscribe(result => {
      if (result) {
        this.getCategories();
      }
    })
  }

  openDeleteDialog() {
    var _popUp = this.dialog.open(AddNewCategoryDialog, {
      width: '30%',
      data: { categories: this.categories, isAddNewQuestion: false } //can send available categories
    });
    _popUp.afterClosed().subscribe(result => {
      if (result) {
        this.getCategories();
      }
    })
  }

  applyFilter() {
    this.filterValue = this.filterValue.trim(); // Remove whitespace
    this.filterValue = this.filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = this.filterValue;
  }
  // addNewRow() {
  //   this.openModal()
  // }
  submit() {
    this.dataArray.forEach((row) => {});
  }
  deleteRow(questionMappingId: number, categoryId: number) {
    const dataSource = this.dataSourceMap.get(categoryId);
    const data = dataSource.data;
    const index = data.findIndex(
      (row) => row.QuestionMappingId === questionMappingId
    );
    if (index !== -1) {
      data.splice(index, 1);
      dataSource.data = data;
    }
    this.auditOverviewService.DeleteQuestion(questionMappingId).subscribe(
      (Response) => {
        console.log(Response);
      },
      (error) => {
        console.error("Error saving data", error);
      }
    );
  }

  editRow(row: any, categoryId: number) {
    row.isEditMode = true;
  }

  Save(row: any, categoryId: number) {
    row.isEditMode = false;
    this.dataArray = [];
    const tempObj: questionType = {
      QuestionId: row.QuestionId,
      QuestionMappingId: row.QuestionMappingId,
      categoryId: categoryId,
      weightage: row.Weightage,
      SubCategoryId: row.SubcategoryId,
      QuestionText: row.Question,
      // technologyId: row.TechnologyId,
      priorityOrder: 0,
      isActive: true,
    };
    this.auditOverviewService.AddorUpdateQuestion(tempObj).subscribe(
      (response) => {
        console.log("Data saved successfully", response);
      },
      (error) => {
        console.error("Error saving data", error);
      }
    );
  }

  isPopupOpen = false;
 openDialog(): void {
    this.isPopupOpen = true;
    document.body.style.overflow = 'hidden';
    const dialogRef = this.dialog.open(AddNewQuestionComponent, {
      width: '580px',
      data: {
        categories: this.categories,
        subCategories: this.subCategories
      }
    });
    
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // Save the new question data when dialog is closed and form is submitted
        this.saveModal(result);
      }
    });
  }

  saveModal(data: any) {
    const tempObj: questionType = {
      QuestionId: 0,
      QuestionMappingId: 0,
      categoryId: data.newCategory,
      weightage: data.newWeightage,
      SubCategoryId: data.newSubCategory,
      QuestionText: data.newQuestion,
      priorityOrder: 0,
      isActive: true
    };

    this.auditOverviewService.AddorUpdateQuestion(tempObj).subscribe(response => {
      console.log('Data saved successfully', response);
      this.cdr.markForCheck(); // Trigger change detection
    }, error => {
      console.error('Error saving data', error);
    });
  }

  UpdateWeightage(event: any) {
    this.newWeightage = event.target.value;
  }

  getsubCategories() {
    this.auditOverviewService.getSubCategoryDropdowns().subscribe(
      (response) => {
        if (response?.length > 0) {
          this.subCategories = response;
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getTechnologies() {
    this.auditOverviewService.GetTechnologiesDropdown().subscribe(
      (response) => {
        if (response?.length > 0) {
          this.technologies = response;
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getQuestions(categoryId: any) {
    this.dataArray = [];
    this.questionsService.getQuestions(categoryId).subscribe((response) => {
      if (response.length > 0) {
        this.dataArray = response.map((question) => {
          return {
            QuestionMappingId: question.questionMappingId,
            QuestionId: question.questionId,
            SubcategoryId: question.subCategoryId,
            SubCategoryName: question.category,
            Question: question.questions,
            Weightage: question.weightage,
            TechnologyId: question.technologyId,
            Technology: question.technologyName,
          };
        });
        const dataSource = new MatTableDataSource<questionType>(this.dataArray);
        this.dataSourceMap.set(categoryId, dataSource);
      }
    });
  }

  updateCategory(value: any) {
    console.log(value.target);
    this.newCategory = value.target.value;
  }
  updateSubCategory(value: any) {
    this.newSubCategory = value.target.value;
  }
  updateQuestion(value: any) {
    this.newQuestion = value.data;
  }
  updateTechnology(value: any) {
    this.newTechnology = value.target.value;
  }

  closeModal() {
    this.newWeightage = '';
    this.newSubCategory = 0;
    this.newQuestion = "";
    this.newTechnology = 0;
    this.newCategory = 0;
  }
  // saveModal() {
  //   const tempObj: questionType = {
  //     QuestionId: 0,
  //     QuestionMappingId: 0,
  //     categoryId: this.newCategory,
  //     weightage: this.newWeightage,
  //     SubCategoryId: this.newSubCategory,
  //     QuestionText: this.newQuestion,
  //     // technologyId: this.newTechnology,
  //     priorityOrder: 0,
  //     isActive: true
  //   }
  //   try {
  //     this.auditOverviewService.AddorUpdateQuestion(tempObj).subscribe(response => {
  //       console.log('Data saved successfully', response);

  //       // const data = this.dataSourceMap.get(this.currentCategoryId);
  //       // data.data.push(tempObj);
  //       this.cdr.markForCheck(); 
  //       //.push(tempObj);
  //     }, error => {
  //       console.error('Error saving data', error);
  //     });
  //   }
  //   catch (error) {
  //     console.log(error);
  //   }
  //   this.displayStyle = 'none';
  //   this.newWeightage = '';
  //   this.newSubCategory = 0;
  //   this.newQuestion = '';
  //   this.newTechnology = 0;
  //   this.newCategory = 0;
  // }
  getCategories() {
    this.auditOverviewService.getCategoryDropDown().subscribe(
      (response) => {
        if (response?.length > 0) {
          this.categories = response;
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }
}
export interface questionType {
  QuestionMappingId: number,
  QuestionId: number,
  categoryId: number,
  SubCategoryId: number,
  QuestionText: string,
  weightage: string,
  priorityOrder: number,
  isActive: boolean
}

export interface categoryType {
  // id: number, use this if update functionality is there
  categoryName: string
}

// @Component({
//   selector: "question-master-dialog",
//   templateUrl: "question-master-dialog.html",
//   styleUrls: ["./question-master.component.css"],
// })
// export class DeleteCategoryDialog implements OnInit {

//   categories: any;

//   constructor(
//     private ref:MatDialogRef<DeleteCategoryDialog>,
//     private auditOverviewService: AuditOverviewService,
//     private toastr: ToastrService,
//     private dialog: MatDialog,
//     @Inject(MAT_DIALOG_DATA) public data: any,
//   ) {}

//   ngOnInit() {
//     this.categories = this.data.categories ?? this.getCategories();
//   }

//   getCategories() {
//     this.auditOverviewService.getCategoryDropDown().subscribe(
//       (response) => {
//         if (response?.length > 0) {
//           this.categories = response;
//         }
//       },
//       (error) => {
//         console.log(error);
//       }
//     );
//   }

//   deleteCategoryButtonClicked(data: string) {
//     if (data != "" || data.trim() != '') {
//       const tempObj: categoryType = {
//         categoryName: data
//       }
//       this.auditOverviewService.AddNewCategory(tempObj).subscribe(
//         (response) => {
//           console.log("Data added successfully", response);
//           this.toastr.success('Category added successfully.');
//           this.ref.close(true);
//         },
//         (error) => {
//           console.error("Error adding data", error);
//           this.toastr.error("Error adding the data. Please try again.");
//         }
//       );
//     }
//     else {
//       this.toastr.error('Category name is required.');
//     }
//   }

//   closeDialog() {
//     this.ref.close(false);
//   }
// }


@Component({
  selector: "question-master-dialog",
  templateUrl: "question-master-dialog.html",
  styleUrls: ["./question-master.component.css"],
})
export class AddNewCategoryDialog implements OnInit {
  isAddNewQuestion: boolean;
  categories: any;
  selectedCategory: any;
  categoryName: string;

  constructor(
    private ref:MatDialogRef<AddNewCategoryDialog>,
    private auditOverviewService: AuditOverviewService,
    private toastr: ToastrService,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  ngOnInit(): void {
    this.isAddNewQuestion = this.data.isAddNewQuestion ?? true;
    if (!this.isAddNewQuestion) {
      this.categories = this.data.categories ?? this.getCategories();
    }
  }

  getCategories() {
    this.auditOverviewService.getCategoryDropDown().subscribe(
      (response) => {
        if (response?.length > 0) {
          this.categories = response;
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  addCategoryButtonClicked() {
    if (this.categoryName != "" || this.categoryName.trim() != '') {
      const tempObj: categoryType = {
        categoryName: this.categoryName
      }
      this.auditOverviewService.AddNewCategory(tempObj).subscribe(
        (response) => {
          console.log("Data added successfully", response);
          this.toastr.success('Category added successfully.');
          this.ref.close(true);
        },
        (error) => {
          console.error("Error adding data", error);
          this.toastr.error("Error adding the data. Please try again.");
        }
      );
    }
    else {
      this.toastr.error('Category name is required.');
    }
  }

  deleteCategoryButtonClicked() {
    
    if (this.selectedCategory) {
      this.auditOverviewService.DeleteCategory(this.selectedCategory).subscribe(
        (response) => {
          console.log("Data deleted successfully", response);
          this.toastr.success('Category deleted successfully.');
          this.ref.close(true);
        },
        (error) => {
          console.error("Error deleting the data", error);
          this.toastr.error("Error deleting the data. Please try again.");
        }
      );
    } else {
      this.toastr.error('Please select a category to delete');
    }
  }

  closeDialog() {
    this.ref.close(false);
  }
}